var map = {
	"./ContactBackground.png": 113,
	"./MSS LOGO-white.png": 22,
	"./MSS Logo-100.jpg": 62,
	"./Star.png": 38,
	"./client.jpg": 37,
	"./client1.png": 114,
	"./costumer.png": 115,
	"./delivery.png": 116,
	"./logo.png": 54,
	"./package.png": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 274;